import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Rental.css";

function Rental() {
  const { t } = useTranslation();

  const categories = [
    {
      number: "01",
      key: "bridalRobes",
      firebaseName: "Bridal Robes",
      className: "bridal-robes-category",
      image:
        "https://i.postimg.cc/nL389f6f/Whats-App-Image-2026-08-18-at-9-55-47-PM-(1).jpg",
    },

    {
      number: "02",
      key: "bridesmaids",
      firebaseName: "Bridesmaids",
      className: "bridesmaids-category",
      image:
        "https://i.postimg.cc/L4BWJpfW/Whats-App-Image-2026-08-18-at-9-55-47-PM-(3).jpg",
    },
  ];

  return (
    <section
      className="rental-categories"
      id="rental-categories"
    >
      {/* ================= HEADING ================= */}

      <div className="rental-categories-heading">
        <span className="rental-label">
          {t("rental.label")}
        </span>

        <h2>
          {t("rental.title1")}
          <br />
          <span>{t("rental.title2")}</span>
        </h2>

        <div className="rental-divider">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>
      </div>

      {/* ================= CATEGORIES ================= */}

      <div className="rental-circles">
        {categories.map((category) => {
          const categoryName = t(
            `rental.categories.${category.key}.name`
          );

          const categoryText = t(
            `rental.categories.${category.key}.text`
          );

          return (
            <Link
              key={category.key}
              to={`/gallery/Rental/${encodeURIComponent(
                category.firebaseName
              )}`}
              className={`rental-category-circle ${category.className}`}
              style={{
                backgroundImage: `url("${category.image}")`,
              }}
            >
              {/* Overlay */}

              <div className="rental-circle-overlay"></div>

              {/* Content */}

              <div className="rental-circle-content">
                <span className="rental-number">
                  {category.number}
                </span>

                <h3>{categoryName}</h3>

                <div className="rental-small-line">
                  <span></span>
                  <i>✦</i>
                  <span></span>
                </div>

                <p>{categoryText}</p>

                <div className="rental-arrow">
                  ↗
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default Rental;